export const shutDown = 'e.g. -shut down "xxxx.exe"'
export const installation = "e.g. -s for silent installation"
export const storedLocation = 'C:/users/public/downloads'
